import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VerifyEmailSectionComponent } from '../app/login/containers/verify-email-section/verify-email-section.component';
import { AccessAccountSectionComponent } from '../app/login/containers/access-account-section/access-account-section.component';
import { ForgotPasswordSectionComponent } from '../app/login/containers/forgot-password-section/forgot-password-section.component';
import { ResetPasswordSectionComponent } from '../app/login/containers/reset-password-section/reset-password-section.component';
import { RegisterSectionComponent } from '../app/register/containers/register-section/register-section.component';
import { ValidateEmailSectionComponent } from '../app/register/containers/validate-email-section/validate-email-section.component';
import { SetPasswordSectionComponent } from '../app/register/containers/set-password-section/set-password-section.component';
import { BookingSectionComponent } from '../app/booking/containers/booking-section/booking-section.component';
import { StepLocationComponent } from '../app/booking/containers/step-location/step-location.component';
import { StepTimeComponent } from '../app/booking/containers/step-time/step-time.component';
import { StepPaymentComponent } from '../app/booking/containers/step-payment/step-payment.component';
import { D2dBookingSwitchComponent } from './booking/components/d2d-booking-switch/d2d-booking-switch.component';
import { VerifySectionComponent } from '../app/verify/containers/verify-section/verify-section.component';
import { Error500Component } from '../app/error-pages/containers/error-500/error-500.component';
import { Error404Component } from '../app/error-pages/containers/error-404/error-404.component';
import { UpsellComponent } from './booking/components/upsell-timeslot/upsell.component';
import { StepHubDropComponent } from './booking/containers/step-hub-drop/step-hub-drop.component';
import { FlybackComponent } from './booking/containers/flyback/flyback.component';
import { AccessAccountOtpSectionComponent } from '../app/login/containers/access-account-otp-section/access-account-otp-section.component';
import { AccessOptionsSectionComponent } from '../app/login/containers/access-options-section/access-options-section.component';
import { AccountDetailsSectionComponent } from '../app/register/containers/account-details-section/account-details-section.component';

const appRoutes: Routes = [
  {
    path: 'flight-finder',
    loadChildren: () => import('../app/flight-finder/flight-finder-section.module').then(m => m.FlightFinderSectionModule)
  },
  {
    path: 'abc',
    component: BookingSectionComponent,
    data: { bookingProduct: 'abc' },
    children: [
      {
        path: 'collection-location',
        component: StepLocationComponent,
        data: { title: 'Choose collection location' }
      },
      // {
      //   path: 'collection-post-office',
      //   component: StepHubDropComponent,
      //   data: { title: 'Choose collection post-office' }
      // },
      {
        path: 'collection-time',
        component: StepTimeComponent,
        data: { title: 'Choose collection time' }
      },
      {
        path: 'payment',
        component: StepPaymentComponent,
        data: { title: 'Confirm payment' }
      },
      {
        path: 'upgrade-ccd',
        component: UpsellComponent,
        data: { title: 'Upsell' }
      },
    ]
  },
  {
    path: 'ccd',
    component: BookingSectionComponent,
    data: { bookingProduct: 'ccd' },
    children: [
      {
        path: 'delivery-location',
        component: StepLocationComponent,
        data: { title: 'Choose delivery location' }
      },
      {
        path: 'delivery-time',
        component: StepTimeComponent,
        data: { title: 'Choose delivery time' }
      },
      {
        path: 'payment',
        component: StepPaymentComponent,
        data: { title: 'Confirm payment' }
      },
      {
        path: 'upgrade-abc',
        component: UpsellComponent,
        data: { title: 'Upsell' }
      },
    ]
  },
  {
    path: 'redirectingTo',
    component: D2dBookingSwitchComponent
  },
  {
    path: 'fly-back-details',
    component: FlybackComponent
  },
  {
    path: 'my-account',
    loadChildren: () => import('../app/my-account/my-account-section.module').then(m => m.MyAccountSectionModule),
  },
  // Step I
  {
    path: 'login',
    component: VerifyEmailSectionComponent,
    data: { title: 'Login to your account' }
  },
  // Step II
  {
    path: 'access-options',
    component: AccessOptionsSectionComponent,
    data: { title: 'Login options' }
  },
  // Step III : Login with Password
  {
    path: 'access-account',
    component: AccessAccountSectionComponent,
    data: { title: 'Access your account', errPageCode: '32' }
  },
  // Step III : Login with OTP
  {
    path: 'access-account-otp',
    component: AccessAccountOtpSectionComponent,
    data: { title: 'Login by OTP', errPageCode: '33' }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordSectionComponent,
    data: { title: 'Reset your password', errPageCode: '34' }
  },
  {
    path: 'validate-email',
    component: ValidateEmailSectionComponent,
    data: { title: 'Validate your email address' }
  },
  {
    path: 'verify',
    component: VerifySectionComponent,
    data: { title: 'AirPortr' }
  },
  // {
  //   path: 'reset-password',
  //   component: ResetPasswordSectionComponent,
  //   data: { title: 'Reset your password' }
  // },
  {
    path: 'set-password',
    component: SetPasswordSectionComponent,
    data: { title: 'Set your password' }
  },
  // Step IV : Provide USer Details
  {
    path: 'account-details',
    component: AccountDetailsSectionComponent,
    data: { title: 'Your account details', errPageCode: '35' }
  },
  {
    path: 'complete',
    loadChildren: () => import('../app/booking-complete/booking-complete.module').then(m => m.CompleteSectionModule)
  },
  {
    path: 'error-500',
    component: Error500Component,
    data: { title: 'AirPortr' }
  },
  {
    path: 'error-404',
    component: Error404Component,
    data: { title: 'AirPortr' }
  },
  {
    path: 'quote',
    redirectTo: 'flight-finder/search?start-booking=true',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: 'flight-finder/search?start-booking=true',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/error-404'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledNonBlocking', scrollOffset: [0, 0], scrollPositionRestoration: 'top' })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { };
